module.exports = __webpack_public_path__ + "img/map-sjyy.34acf416.png";